// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2IyGl","footer":"Form_footer__157r8"};